import DownloadApps from 'common/DownloadApps';
import StaticLayout from 'common/Layout/StaticLayout';
import React from 'react';
import { __t } from '../common/i18n';
import Seo, { SITE_URL } from 'common/Seo';
import Breadcrumb from 'common/Breadcrumb';
import Head from 'next/head';
import { safeJsonLd } from 'common/utils/safeJsonLd';

const APPS_DESCRIPTION = 'با دانلود اپلیکیشن‌های فیلم‌نت در هر لحظه و هر جا به آسانی به تمامی محتوای فیلم‌نت دسترسی داشته باشید و از آن لذت ببرید. در زیر امکان دانلود اپلیکیشن های فیلم‌نت به دو صورت مستقیم و دریافت از فروشگاه های آنلاین فراهم شده است.';

const appsSchema = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'فیلم‌نت',
  alternateName: 'Filmnet',
  applicationCategory: 'EntertainmentApplication',
  operatingSystem: 'ANDROID, iOS, SMART_TV',
  offers: { '@type': 'Offer', price: '0', priceCurrency: 'IRR' },
  description: APPS_DESCRIPTION,
  url: `${SITE_URL}/apps`,
};

export default function Apps() {
  return (
    <>
      <Seo
        title={`${__t('static_siteName')} | ${__t('static.download.apps.title')}`}
        description={APPS_DESCRIPTION}
        path="/apps"
      />
      <Head>
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: safeJsonLd(appsSchema) }} />
      </Head>
      <Breadcrumb items={[
        { name: __t('common.home'), url: '/' },
        { name: __t('static.download.apps.title'), url: '/apps' },
      ]} />
      <StaticLayout cover="/static/images/static_pages/apps_cover_img.png" containCover>
        <DownloadApps />
      </StaticLayout>
    </>
  );
}
